export default __webpack_public_path__ + "brightMap.png";